export default __webpack_public_path__ + "static/media/videocam_off.d5bf4932.svg";